import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useLocale } from './../../components/special/LanguageProvider';
import { apiGetCall, apiPostCall, isResultOk } from './../../components/special/apiCall';
import EditForm from 'components/form/EditForm';
import EditFormFieldTable from 'components/form/EditFormFieldTable';
import InputDate from './../../components/input/InputDate';
import InputDropDownList from './../../components/input/InputDropDownList';
import InputText from './../../components/input/InputText';
import InputRadioButtons from './../../components/input/InputRadioButtons';
import ListTable from './../../components/form/ListTable';
import TextDate from './../../components/text/TextDate';
import TextAmount from 'components/text/TextAmount';
import InputAmount from './../../components/input/InputAmount';
import InputCheckBox from 'components/input/InputCheckBox';
import Header from 'components/frame/Header';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const AgreementCreate = ({ history }) => {

    const params = new URLSearchParams(useLocation().search);
    const setCheckErrorItems = useErrorContext();
    const setIsPageLoading = usePageLoadingContext();
    const { t } = useLocale();

    //Init blank formdata record.
    const [formData, setFormData] = useState({
        agreementData: {
            agreementTypeID: 1,
            name: null,
            activeFrom: new Date(),
            activeTo: null,
            indexTableId: null,
            active: true,
            statementFeeLine: {
                agreementLineTypeID: 1,
                feeInfo: {
                    feeAmount: 0
                },
                active: false
            },
            outlaidCostFeeLine: {
                agreementLineTypeID: 2,
                feeInfo: {
                    remainderPercentage: 0,
                    interestPercentage: 0
                },
                active: false
            },
            accruedCostNoFeeLine: {
                agreementLineTypeID: 3,
                active: true

            },
            accruedCostStatusFeeLine: {
                agreementLineTypeID: 4,
                feeInfo: [{
                    claimStatus: 1,
                    amount: 0,
                    percentage: 0
                },
                {
                    claimStatus: 2,
                    amount: 0,
                    percentage: 0
                },
                {
                    claimStatus: 3,
                    amount: 0,
                    percentage: 0
                },
                {
                    claimStatus: 4,
                    amount: 0,
                    percentage: 0
                }],
                active: false
            },
            accruedCostAmountFeeLine: {
                agreementLineTypeID: 5,
                feeInfo: [{
                    itemId: 1,
                    claimAmount: 0,
                    feeAmount: 0
                },
                {
                    itemId: 2,
                    claimAmount: 0,
                    feeAmount: 0
                },
                {
                    itemId: 3,
                    claimAmount: 0,
                    feeAmount: 0
                },
                {
                    itemId: 4,
                    claimAmount: 0,
                    feeAmount: 0
                },
                {
                    itemId: 5,
                    claimAmount: 0,
                    feeAmount: 0
                },
                {
                    itemId: 6,
                    claimAmount: 0,
                    feeAmount: 0
                },
                {
                    itemId: 7,
                    claimAmount: 0,
                    feeAmount: 0
                },
                {
                    itemId: 8,
                    claimAmount: 0,
                    feeAmount: 0
                },
                {
                    itemId: 9,
                    claimAmount: 0,
                    feeAmount: 0
                },
                {
                    itemId: 10,
                    claimAmount: 0,
                    feeAmount: 0
                }],
                active: false
            },
            paymentAllocationLine: {
                agreementLineTypeID: 6,
                allocationInfo: {
                    accruedCostPercentage: 0,
                    accruedCostInterestPercentage: 0,
                    outlaidCostPercentage: 0,
                    outlaidCostInterestPercentage: 0,
                    minCreditorPercentage: 0,
                    lawyerTotalRemainderPercentage: 0
                },
                active: false
            }
        }, 
        cancelAgreementAcrCostSelected: 1
    });


    const [lookupData, setLookupData] = useState({
        agreementTypeList: [],
        agreementLineTypeList: [],
        indexTableList: [],
        accruedCostSelectionList: []
    });


    const goBack = () => {
        history.push("/admin/agreements");
    }

    const loadLookupData = async () => {
        //Load all the data at the same time.     
        let [agreementTypeList, agreementLineTypeList, indexTableList] = await Promise.all([
            apiGetCall(BASE_URL + '/admin/agreement/types'),
            apiGetCall(BASE_URL + '/admin/agreement/lines/types'),
            apiGetCall(BASE_URL + '/admin/list/indextable'),
        ]);
        //Check we need to display any critical errors.
        setCheckErrorItems([agreementTypeList, agreementLineTypeList]);

        //Translate the data into what we want to use.
        setLookupData({
            agreementTypeList: agreementTypeList,
            agreementLineTypeList: agreementLineTypeList,
            indexTableList: indexTableList,
            accruedCostSelectionList: [{
                itemID: 1,
                name: "Ekki þóknun fyrir áfallinn kostnað"
            },
            {
                itemID: 2,
                name: "Áfallinn - Staða máls"
            },
            {
                itemID: 3,
                name: "Áfallinn - Fjárhæð máls"
            }]
        });
    }


    const loadFormData = async () => {
        setIsPageLoading(true);
        let newFormData = { ...formData };
        let agrTypeID = params.get("agrTypeID");
        newFormData.agreementData.agreementTypeID = agrTypeID;

        //Lookup data.
        await loadLookupData();

        setFormData(newFormData);

        setIsPageLoading(false);

    }

    useEffect(() => {
        loadFormData();
    }, []);

    const onSaveClick = async () => {

        setIsPageLoading(true);
        let requestResult = null;

        requestResult = await apiPostCall(BASE_URL + '/admin/agreement/save', formData.agreementData);
        //console.log("res", requestResult);

        if (isResultOk(requestResult, setCheckErrorItems)) {
            goBack();
        }
        setIsPageLoading(false);
    }

    const onBackClick = () => {
        goBack();
    }

    const validateInput = async () => {
        let messages = [];

        if (formData.agreementData.name == null || formData.agreementData.name == "") {
            messages.push("Heiti samnings vantar");
        }

        if (formData.agreementData.accruedCostAmountFeeLine.active == false && formData.agreementData.accruedCostNoFeeLine.active == false && formData.agreementData.accruedCostStatusFeeLine.active == false) {
            messages.push("Verður að velja aðferð fyrir áfallinn kostnað!");
        }
        return messages;
    }

    const onCancelRadioButtonChange = (value) => {
        let newFormData = { ...formData };
        newFormData.cancelAgreementAcrCostSelected = value;
        if (value == 1) {
            newFormData.agreementData.accruedCostNoFeeLine.active = true;
            newFormData.agreementData.accruedCostAmountFeeLine.active = false;
            newFormData.agreementData.accruedCostStatusFeeLine.active = false;
        } else if (value == 2) {
            newFormData.agreementData.accruedCostNoFeeLine.active = false;
            newFormData.agreementData.accruedCostAmountFeeLine.active = false;
            newFormData.agreementData.accruedCostStatusFeeLine.active = true;
        } else if (value == 3) {
            newFormData.agreementData.accruedCostNoFeeLine.active = false;
            newFormData.agreementData.accruedCostAmountFeeLine.active = true;
            newFormData.agreementData.accruedCostStatusFeeLine.active = false;
        }
        setFormData(newFormData);
    }

    const onDatePickerChange = (pick, value) => {
        let newFormData = { ...formData };

        if (pick == "activeTo") {
            newFormData.agreementData.activeTo = value;
        } else if (pick = "activeFrom") {
            newFormData.agreementData.activeFrom = value;
        }
        setFormData(newFormData);
    }

    const onNameInputChange = (value) => {
        let newFormData = { ...formData };
        newFormData.agreementData.name = value;
        setFormData(newFormData);
    }

    const onCbChanged = (cb, value) => {
        let newFormData = { ...formData };
        if (cb == "statementFeeCB") {
            formData.agreementData.statementFeeLine.active = value;
        } else if (cb == "outlaidFeeCB") {
            formData.agreementData.outlaidCostFeeLine.active = value;
        }
        setFormData(newFormData);

    }

    const onDDChanged = (dd, value) => {
        let newFormData = { ...formData };
        if (dd == "IndexTable") {
            newFormData.agreementData.indexTableId = value;
        } else if (dd == "agrType"){
            newFormData.agreementData.agreementTypeID = value;
        }
        setFormData(newFormData);
    }

    const onAmountInputChange = (obj, idx, value) => {
        let newFormData = { ...formData };
        if (obj == "statementFeeLine") {
            newFormData.agreementData.statementFeeLine.feeInfo.feeAmount = value;
        } else if (obj == "outlaidCostFeeLine-remainderPercentage") {
            newFormData.agreementData.outlaidCostFeeLine.feeInfo.remainderPercentage = value;
        } else if (obj == "outlaidCostFeeLine-interestPercentage") {
            newFormData.agreementData.outlaidCostFeeLine.feeInfo.interestPercentage = value;
        } else if (obj == "accruedStatusAmount") {
            newFormData.agreementData.accruedCostStatusFeeLine.feeInfo[idx].amount = value;
        } else if (obj == "accruedStatusPercentage") {
            newFormData.agreementData.accruedCostStatusFeeLine.feeInfo[idx].percentage = value;
        } else if (obj == "accruedClaimAmount") {
            newFormData.agreementData.accruedCostAmountFeeLine.feeInfo[idx].claimAmount = value;
        } else if (obj == "accruedAmount") {
            newFormData.agreementData.accruedCostAmountFeeLine.feeInfo[idx].feeAmount = value;
        } else if (obj == "outlaidAllocation") {
            newFormData.agreementData.paymentAllocationLine.allocationInfo.outlaidCostPercentage = value;   
        }  else if (obj == "outlaidInterestAllocation") {
            newFormData.agreementData.paymentAllocationLine.allocationInfo.outlaidCostInterestPercentage = value;   
        } else if (obj == "accruedAllocation") {
            newFormData.agreementData.paymentAllocationLine.allocationInfo.accruedCostPercentage = value;   
        }  else if (obj == "accruedInterestAllocation") {
            newFormData.agreementData.paymentAllocationLine.allocationInfo.accruedCostInterestPercentage = value;   
        } else if (obj == "minCreditorAllocation") {
            newFormData.agreementData.paymentAllocationLine.allocationInfo.minCreditorPercentage = value;  
            newFormData.agreementData.paymentAllocationLine.allocationInfo.lawyerTotalRemainderPercentage = 0; 
        }  else if (obj == "lawyerTotalAllocation") {
            newFormData.agreementData.paymentAllocationLine.allocationInfo.lawyerTotalRemainderPercentage = value;  
            newFormData.agreementData.paymentAllocationLine.allocationInfo.minCreditorPercentage = 0; 
        }
        setFormData(newFormData);
    }

    return (
        <EditForm title={"Skilgreina nýjan Samning"} onSubmitClick={onSaveClick} onBackClick={onBackClick} onValidate={validateInput}>
            <EditFormFieldTable fields={[
                {
                    title: "Nýr samningur",
                    edit: () => <InputDropDownList
                        name="Tegund"
                        disabled={false}
                        list={lookupData.agreementTypeList}
                        keyField="itemID"
                        displayField={(item) => { return item.name }}
                        defaultValue={formData.agreementData.agreementTypeID}
                        onChange={(value) => onDDChanged("agrType", value)} //{(value) => setWorkingData({ ...workingData, agreementTypeID : value})}
                        nullable={true}
                        nullableItem={{ itemID: null, name: "" }}
                    />
                },
                {
                    title: "Heiti samnings",
                    edit: () => (<InputText name="name" value={formData.agreementData.name} disabled={false} onChange={(value) => onNameInputChange(value)} />)
                },
                {
                    title: "Gildir frá",
                    edit: () => (<InputDate name="activeFrom" value={formData.agreementData.activeFrom} onChange={(value) => onDatePickerChange("activeFrom", value)} />)
                },
                {
                    title: "Gildir til",
                    edit: () => (<InputDate name="activeTo" value={formData.agreementData.activeTo} disabled={(formData.agreementData.agreementTypeID != 1)} onChange={(value) => onDatePickerChange("activeTo", value)} />)
                },
                {
                    title: "Vísitala",
                    edit: () => <InputDropDownList
                        name="IndexTable"
                        disabled={formData.agreementData.agreementTypeID != 1}
                        list={lookupData.indexTableList}
                        keyField="itemID"
                        displayField={(item) => { return item.name }}
                        defaultValue={formData.agreementData.indexTableId}
                        onChange={(value) => onDDChanged("IndexTable", value)}
                        nullable={true}
                        nullableItem={{ itemID: null, name: "" }}
                    />
                },
            ]} />
            <div style={{ display: (formData.agreementData.agreementTypeID == 2) ? 'block' : 'none' }}>
            <EditFormFieldTable fields={[
                     {
                        title: "Útlagður kostnaður - % af eftirstöðvum",
                        edit: () => (<InputAmount name="outlaidAllocation" value={formData.agreementData.paymentAllocationLine.allocationInfo.outlaidCostPercentage} decimalScale={2} min={0} max={100} onChange={(value) => onAmountInputChange("outlaidAllocation", null, value)} />)
                    },
                    {
                        title: "Útlagður kostnaður Vextir - % af eftirstöðvum",
                        edit: () => (<InputAmount name="outlaidInterestAllocation" value={formData.agreementData.paymentAllocationLine.allocationInfo.outlaidCostInterestPercentage} decimalScale={2} min={0} max={100} onChange={(value) => onAmountInputChange("outlaidInterestAllocation", null, value)} />)
                    },
                    {
                        title: "Áfallinn kostnaður - % af eftirstöðvum",
                        edit: () => (<InputAmount name="accruedAllocation" value={formData.agreementData.paymentAllocationLine.allocationInfo.accruedCostPercentage} decimalScale={2} min={0} max={100} onChange={(value) => onAmountInputChange("accruedAllocation", null, value)} />)
                    },
                    {
                        title: "Áfallinn kostnaður Vextir - % af eftirstöðvum",
                        edit: () => (<InputAmount name="accruedInterestAllocation" value={formData.agreementData.paymentAllocationLine.allocationInfo.accruedCostInterestPercentage} decimalScale={2} min={0} max={100} onChange={(value) => onAmountInputChange("accruedInterestAllocation", null, value)} />)
                    },
                    {
                        title: "Lágmark kröfuhafa - % af eftirstöðvum",
                        edit: () => (<InputAmount name="minCreditorAllocation" value={formData.agreementData.paymentAllocationLine.allocationInfo.minCreditorPercentage} decimalScale={2} min={0} max={100} onChange={(value) => onAmountInputChange("minCreditorAllocation", null, value)} />)
                    },
                    {
                        title: "Hlutfall eftirst. Lögm / kröfuhafa - % af eftirstöðvum",
                        edit: () => (<InputAmount name="lawyerTotalAllocation" value={formData.agreementData.paymentAllocationLine.allocationInfo.lawyerTotalRemainderPercentage} decimalScale={2} min={0} max={100} onChange={(value) => onAmountInputChange("lawyerTotalAllocation", null, value)} />)
                    }
                ]} />
            </div> 
            <div style={{ display: (formData.agreementData.agreementTypeID == 1) ? 'block' : 'none' }}>
                <InputCheckBox name={"statementFeeCB"} label={"Virkja kröfulýsingu"} value={formData.agreementData.statementFeeLine.active} onChange={(value) => onCbChanged("statementFeeCB", value)} />
                <EditFormFieldTable fields={[
                    {
                        title: "Kröfulýsing í þrotabú (kr)",
                        edit: () => (<InputAmount name="statementFeeLine" value={formData.agreementData.statementFeeLine.feeInfo.feeAmount} disabled={!(formData.agreementData.statementFeeLine.active)} onChange={(value) => onAmountInputChange("statementFeeLine", null, value)} />)
                    }
                ]} />
                <div>
                    <InputCheckBox name={"outlaidFeeCB"} label={"Virkja Útlagðan kostnað"} value={formData.agreementData.outlaidCostFeeLine.active} onChange={(value) => onCbChanged("outlaidFeeCB", value)} />
                    <EditFormFieldTable fields={[
                        {
                            title: "Útlagður kostnaður",
                            edit: (
                                <div>
                                    <EditFormFieldTable fields={[
                                        {
                                            title: "Þóknun - % af eftirstöðvum",
                                            edit: () => (<InputAmount name="remainderPercentage" value={formData.agreementData.outlaidCostFeeLine.feeInfo.remainderPercentage} disabled={!(formData.agreementData.outlaidCostFeeLine.active)} decimalScale={2} min={0} max={100} onChange={(value) => onAmountInputChange("outlaidCostFeeLine-remainderPercentage", null, value)} />)
                                        }
                                    ]} />
                                    <EditFormFieldTable fields={[
                                        {
                                            title: "Vextir - % af eftirstöðvum",
                                            edit: () => (<InputAmount name="interestPercentage" value={formData.agreementData.outlaidCostFeeLine.feeInfo.interestPercentage} disabled={!(formData.agreementData.outlaidCostFeeLine.active)} decimalScale={2} min={0} max={100} onChange={(value) => onAmountInputChange("outlaidCostFeeLine-interestPercentage", null, value)} />)
                                        }
                                    ]} />
                                </div>
                            )
                        }
                    ]} />
                </div>
                <EditFormFieldTable fields={[
                    {
                        title: "Áfallinn kostnaður",
                        edit: () => (<InputRadioButtons name="AccruedCost" list={lookupData.accruedCostSelectionList} keyField="itemID" displayField="name" defaultValue={formData.cancelAgreementAcrCostSelected} disabled={false} onChange={(value) => onCancelRadioButtonChange(value)} />)

                    }
                ]} />
            </div>
            <div style={{ display: (formData.agreementData.accruedCostStatusFeeLine.active || formData.agreementData.accruedCostAmountFeeLine.active) ? 'block' : 'none' }}>
                {formData.agreementData.accruedCostStatusFeeLine.active ? (
                    <div>
                        <span style={{ fontSize: 20 }}>Áfallinn - Staða máls</span>
                        <EditFormFieldTable fields={[
                            {
                                title: "Innheimtubréf",
                                edit: (
                                    <div>
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "Þóknun - föst upphæð (kr)",
                                                edit: () => (<InputAmount name="accruedStatusAmount" value={formData.agreementData.accruedCostStatusFeeLine.feeInfo[0].amount} onChange={(value) => onAmountInputChange("accruedStatusAmount", 0, value)} />)
                                            }
                                        ]} />
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "þóknun - % af kostnaði",
                                                edit: () => (<InputAmount name="accruedStatusPercentage" value={formData.agreementData.accruedCostStatusFeeLine.feeInfo[0].percentage} decimalScale={2} min={0} max={100} onChange={(value) => onAmountInputChange("accruedStatusPercentage", 0, value)} />)
                                            }
                                        ]} />
                                    </div>
                                )
                            }
                        ]} />
                        <EditFormFieldTable fields={[
                            {
                                title: "Stefna / Greiðsluáskorun",
                                edit: (
                                    <div>
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "Þóknun - föst upphæð (kr)",
                                                edit: () => (<InputAmount name="accruedStatusAmount" value={formData.agreementData.accruedCostStatusFeeLine.feeInfo[1].amount} onChange={(value) => onAmountInputChange("accruedStatusAmount", 1, value)} />)
                                            }
                                        ]} />
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "þóknun - % af kostnaði",
                                                edit: () => (<InputAmount name="accruedStatusPercentage" value={formData.agreementData.accruedCostStatusFeeLine.feeInfo[1].percentage} decimalScale={2} min={0} max={100} onChange={(value) => onAmountInputChange("accruedStatusPercentage", 1, value)} />)
                                            }
                                        ]} />
                                    </div>
                                )
                            }
                        ]} />
                        <EditFormFieldTable fields={[
                            {
                                title: "Fjárnámsstig",
                                edit: (
                                    <div>
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "Þóknun - föst upphæð (kr)",
                                                edit: () => (<InputAmount name="accruedStatusAmount" value={formData.agreementData.accruedCostStatusFeeLine.feeInfo[2].amount} onChange={(value) => onAmountInputChange("accruedStatusAmount", 2, value)} />)
                                            }
                                        ]} />
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "þóknun - % af kostnaði",
                                                edit: () => (<InputAmount name="accruedStatusPercentage" value={formData.agreementData.accruedCostStatusFeeLine.feeInfo[2].percentage} decimalScale={2} min={0} max={100} onChange={(value) => onAmountInputChange("accruedStatusPercentage", 2, value)} />)
                                            }
                                        ]} />
                                    </div>
                                )
                            }
                        ]} />
                        <EditFormFieldTable fields={[
                            {
                                title: "Nauðungarsölustig",
                                edit: (
                                    <div>
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "Þóknun - föst upphæð (kr)",
                                                edit: () => (<InputAmount name="accruedStatusAmount" value={formData.agreementData.accruedCostStatusFeeLine.feeInfo[3].amount} onChange={(value) => onAmountInputChange("accruedStatusAmount", 3, value)} />)
                                            }
                                        ]} />
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "þóknun - % af kostnaði",
                                                edit: () => (<InputAmount name="accruedStatusPercentage" value={formData.agreementData.accruedCostStatusFeeLine.feeInfo[3].percentage} decimalScale={2} min={0} max={100} onChange={(value) => onAmountInputChange("accruedStatusPercentage", 3, value)} />)
                                            }
                                        ]} />
                                    </div>
                                )
                            }
                        ]} />
                    </div>) : (
                    <div>
                        <span style={{ fontSize: 20 }}>Áfallinn - Fjárhæð máls</span>
                        <EditFormFieldTable fields={[
                            {
                                title: "1",
                                edit: (
                                    <div>
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "Fjárhæð allt að kr",
                                                edit: () => (<InputAmount name="accruedClaimAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[0].claimAmount} onChange={(value) => onAmountInputChange("accruedClaimAmount", 0, value)} />)
                                            }
                                        ]} />
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "þóknun kr",
                                                edit: () => (<InputAmount name="accruedAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[0].feeAmount} onChange={(value) => onAmountInputChange("accruedAmount", 0, value)} />)
                                            }
                                        ]} />
                                    </div>
                                )
                            }
                        ]} />
                        <EditFormFieldTable fields={[
                            {
                                title: "2",
                                edit: (
                                    <div>
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "Fjárhæð allt að kr",
                                                edit: () => (<InputAmount name="accruedClaimAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[1].claimAmount} onChange={(value) => onAmountInputChange("accruedClaimAmount", 1, value)} />)
                                            }
                                        ]} />
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "þóknun kr",
                                                edit: () => (<InputAmount name="accruedAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[1].feeAmount} onChange={(value) => onAmountInputChange("accruedAmount", 1, value)} />)
                                            }
                                        ]} />
                                    </div>
                                )
                            }
                        ]} />
                        <EditFormFieldTable fields={[
                            {
                                title: "3",
                                edit: (
                                    <div>
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "Fjárhæð allt að kr",
                                                edit: () => (<InputAmount name="accruedClaimAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[2].claimAmount} onChange={(value) => onAmountInputChange("accruedClaimAmount", 2, value)} />)
                                            }
                                        ]} />
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "þóknun kr",
                                                edit: () => (<InputAmount name="accruedAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[2].feeAmount} onChange={(value) => onAmountInputChange("accruedAmount", 2, value)} />)
                                            }
                                        ]} />
                                    </div>
                                )
                            }
                        ]} />
                        <EditFormFieldTable fields={[
                            {
                                title: "4",
                                edit: (
                                    <div>
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "Fjárhæð allt að kr",
                                                edit: () => (<InputAmount name="accruedClaimAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[3].claimAmount} onChange={(value) => onAmountInputChange("accruedClaimAmount", 3, value)} />)
                                            }
                                        ]} />
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "þóknun kr",
                                                edit: () => (<InputAmount name="accruedAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[3].feeAmount} onChange={(value) => onAmountInputChange("accruedAmount", 3, value)} />)
                                            }
                                        ]} />
                                    </div>
                                )
                            }
                        ]} />
                        <EditFormFieldTable fields={[
                            {
                                title: "5",
                                edit: (
                                    <div>
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "Fjárhæð allt að kr",
                                                edit: () => (<InputAmount name="accruedClaimAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[4].claimAmount} onChange={(value) => onAmountInputChange("accruedClaimAmount", 4, value)} />)
                                            }
                                        ]} />
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "þóknun kr",
                                                edit: () => (<InputAmount name="accruedAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[4].feeAmount} onChange={(value) => onAmountInputChange("accruedAmount", 4, value)} />)
                                            }
                                        ]} />
                                    </div>
                                )
                            }
                        ]} />
                        <EditFormFieldTable fields={[
                            {
                                title: "6",
                                edit: (
                                    <div>
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "Fjárhæð allt að kr",
                                                edit: () => (<InputAmount name="accruedClaimAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[5].claimAmount} onChange={(value) => onAmountInputChange("accruedClaimAmount", 5, value)} />)
                                            }
                                        ]} />
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "þóknun kr",
                                                edit: () => (<InputAmount name="accruedAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[5].feeAmount} onChange={(value) => onAmountInputChange("accruedAmount", 5, value)} />)
                                            }
                                        ]} />
                                    </div>
                                )
                            }
                        ]} />
                        <EditFormFieldTable fields={[
                            {
                                title: "7",
                                edit: (
                                    <div>
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "Fjárhæð allt að kr",
                                                edit: () => (<InputAmount name="accruedClaimAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[6].claimAmount} onChange={(value) => onAmountInputChange("accruedClaimAmount", 6, value)} />)
                                            }
                                        ]} />
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "þóknun kr",
                                                edit: () => (<InputAmount name="accruedAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[6].feeAmount} onChange={(value) => onAmountInputChange("accruedAmount", 6, value)} />)
                                            }
                                        ]} />
                                    </div>
                                )
                            }
                        ]} />
                        <EditFormFieldTable fields={[
                            {
                                title: "8",
                                edit: (
                                    <div>
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "Fjárhæð allt að kr",
                                                edit: () => (<InputAmount name="accruedClaimAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[7].claimAmount} onChange={(value) => onAmountInputChange("accruedClaimAmount", 7, value)} />)
                                            }
                                        ]} />
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "þóknun kr",
                                                edit: () => (<InputAmount name="accruedAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[7].feeAmount} onChange={(value) => onAmountInputChange("accruedAmount", 7, value)} />)
                                            }
                                        ]} />
                                    </div>
                                )
                            }
                        ]} />
                        <EditFormFieldTable fields={[
                            {
                                title: "9",
                                edit: (
                                    <div>
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "Fjárhæð allt að kr",
                                                edit: () => (<InputAmount name="accruedClaimAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[8].claimAmount} onChange={(value) => onAmountInputChange("accruedClaimAmount", 8, value)} />)
                                            }
                                        ]} />
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "þóknun kr",
                                                edit: () => (<InputAmount name="accruedAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[8].feeAmount} onChange={(value) => onAmountInputChange("accruedAmount", 8, value)} />)
                                            }
                                        ]} />
                                    </div>
                                )
                            }
                        ]} />
                        <EditFormFieldTable fields={[
                            {
                                title: "10",
                                edit: (
                                    <div>
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "Fjárhæð allt að kr",
                                                edit: () => (<InputAmount name="accruedClaimAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[9].claimAmount} onChange={(value) => onAmountInputChange("accruedClaimAmount", 9, value)} />)
                                            }
                                        ]} />
                                        <EditFormFieldTable fields={[
                                            {
                                                title: "þóknun kr",
                                                edit: () => (<InputAmount name="accruedAmount" value={formData.agreementData.accruedCostAmountFeeLine.feeInfo[9].feeAmount} onChange={(value) => onAmountInputChange("accruedAmount", 9, value)} />)
                                            }
                                        ]} />
                                    </div>
                                )
                            }
                        ]} />
                    </div>)
                }
            </div>

        </EditForm>
    );
}





